import React, { useEffect, useRef, useReducer, useState, useContext, useMemo } from 'react';

import { ContenedorParametros } from '../../components/utils/ContenedorParametros';
import { Tooltip } from '../../components/utils/Tooltip';
import { BotonNuevo } from '../../components/buttons/BotonNuevo';
import { Modal } from '../../components/modal/Modal';
import { useModal } from '../../../hooks/useModal';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition'
import { agregarDias, convertirFormatoDias, convertirSegundosAFormatoHr, formatDate, formatearFechaHora,  notify,  primeraLetraMayuscula, primeraLetraMayusculaOracion, transformarArchivoUrl, validarExtensionImagen  } from '../../../utils/utils';
import { NuevoSelectAutocomplete } from '../../components/forms/NuevoSelectAutocomplete';
import { useEmpresas } from '../../../hooks/useEmpresas';
import { useIncidencia } from '../../../hooks/GestionIncidencias/useIncidencia';
import { useUsuarios } from '../../../hooks/usuarios/useUsuarios';
import { UserContext } from '../../../context/provider/UserProvider';
import { BotonProcesosPGI } from '../../components/buttons/BotonProcesosPGI';
import { ContenedorBotones } from '../../components/ContenedorBotones';
import { useConceptoIncidencia } from '../../../hooks/GestionIncidencias/useConceptoIncidencia';
import { LineaCarga } from '../../components/LineaCarga';
import { SwitchToggle } from '../../components/SwitchToggle';
import { ContenedorImagen } from '../../components/ContenedorImagen';
import { ContenedorDocumento } from '../../components/ContenedorDocumento';
import { ContenedorTabla } from '../../components/utils/ContenedorTabla';
import { BotonProcesar } from '../../components/buttons/BotonProcesar';
import { DetalleIncidencia } from '../../components/DetalleIncidencia';
import { Lista } from '../../components/Lista';
import { MultiSelectorFecha } from '../../components/pickers/MultiSelectorFecha';
import { Buscador } from '../../components/Buscador';

const archivoReducer = (estado, accion) => {
    switch(accion.tipo){
        case 'Agregar':
            return [...estado, ...accion.carga];
        case 'Remover':
            return estado.filter(file => file.identificador !== accion.carga.identificador);
        case 'Reiniciar':
            return []
        case 'Cargar':
            return accion.carga
        default:
            return estado;
    }
}

const docReducer = (estado, accion) => {
    switch(accion.tipo){
        case 'Agregar':
            return [...estado, ...accion.carga];
        case 'Remover':
            return estado.filter(file => file?.codigo ?
                (file.codigo !== accion.carga.codigo) : (file.identificador !== accion.carga.identificador)
            );
        case 'Reiniciar':
            return []
        case 'Cargar':
            return accion.carga
        default:
            return estado;
    }
}

export const Incidencias = () => {
    const { stateUser } = useContext(UserContext);
    const [ startDate, setStartDate ] = useState(agregarDias(-30))
    const [ endDate, setEndDate ] = useState(formatDate(new Date()));
    const [ despliegue, setDespliegue ] = useState(false);
    const [ ordenAscendenteFecha, setOrdenAscendenteFecha ] = useState(true);
    const [ codigoEstado, setCodigoEstado ] = useState(50);
    const [ procesoElegido, setProcesoElegido ] = useState(0);
    const [ numeroProceso, setNumeroProceso ] = useState(0);
    const [ archivos, dispatch ] = useReducer(archivoReducer, []);
    const [ documentos, envioDoc ] = useReducer(docReducer, []);
    const [ isOpenModalProcesosIncidencia, openModalProcesosIncidencia, closeModalProcesosIncidencia ] = useModal(null);
    const [ isOpenModalRegistro, openModalRegistro, closeModalRegistro ] = useModal(null);
    const [ isOpenModalSeguimiento, openModalSeguimiento, closeModalSeguimiento ] = useModal(null);
    const [ codigoIncidencia, setCodigoIncidencia ] = useState(0)
    const [ numeroFilaSeguimiento, setNumeroFilaSeguimiento ] = useState(0)
    const [ textoBuscador , setTextoBuscador ] = useState('')
    const [ codigoEmpresa, setCodigoEmpresa ] = useState(0)
    const [ codigoRuta, setCodigoRuta ] = useState(0)
    const [ codigoProducto, setCodigoProducto ] = useState(0)
    const [ ordenConfig, setOrdenConfig ] = useState({ tipo: 'fecha' , direccion: 'ascendente'})
    const [ filters, setFilters ] = useState({
        codigoEmpresa: 0,
        codigoRuta: 0,
        codigoProducto: 0,
        textoBuscador: ''
     });

    const idTablaIncidencias = "tabla-incidencias";
    const classNameInput = "py-1 px-2 caret-white containerScroll text-white  rounded  bg-zinc-900 text-l focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:opacity-70 disabled:cursor-not-allowed";
    const classNameSelect = "py-1 px-2 containerScroll text-white  rounded  bg-zinc-900 text-l focus:outline-none focus:ring-1 focus:ring-blue-500";

    const estadosSolicitudes = [
        { codEstado: 50, nomEstado: "Nuevo", abrevEstado: "NUEV"},
        { codEstado: 48, nomEstado: "En Proceso", abrevEstado: "PROC"},
        { codEstado: 59, nomEstado: "Solucionado", abrevEstado: "SOL"},
        { codEstado: 7, nomEstado: "Cerrado", abrevEstado: "CERR"},
    ];
    const procesos = [
        {nombre: 'Validación', numeroEstado: 1, color: ' bg-gray-900 ', descripcion: '' }, //Analizar
        {nombre: 'Derivación', numeroEstado: 2, color: ' bg-gray-800 ', descripcion: ''  }, //Derivar
        {nombre: 'Resolución', numeroEstado: 3, color: ' bg-gray-700 ', descripcion: '' }, //Resolver
        {nombre: 'Cierre', numeroEstado: 4, color: ' bg-gray-600 ', descripcion: '' }, //Cerrar ticket
    ];

    const {
        listening
    } = useSpeechRecognition();

    const {
        empresas,
        listarEmpresas,
        listarRutasPorEmpresa,
        rutas
    } = useEmpresas();

    const {
        usuarios,
        areas,
        listarUsuarios,
        listarAreas
    } = useUsuarios();

    const {
        incidencias,
        listarIncidencias,
        listarProcesosIncidencia,
        procesosIncidencia,
        incidenciaPGI,
        listarUnidadesPorEmpresa,
        unidades,
        resetUnidades,
        editarValorRegistroIncidencia,
        obtenerDetalleIncidencia,
        resetIncidenciaPGI,
        guardarIncidenciaPGI,
        detalleIncidencia,
        imagenesTgps,
        validarIncidencia,
        guardarValidacionIncidencia,
        imagenesValidacion,
        documentosValidacion,
        editarValorValidacion,
        derivarIncidencia,
        guardarDerivacionIncidencia,
        guardarSolucionIncidencia,
        editarValorDerivacion,
        resolverIncidencia,
        editarValorResolucion,
        cierreIncidencia,
        guardarCierreIncidencia,
        editarValorCierre,
        listarTipoCierre,
        imagenesCierre,
        documentosCierre,
        tipoCierreIncidencia,
        listarTipoUrgencia,
        tipoUrgencia,
        listaSeguimientoIncidencia,
        setComentarioSeguimiento,
        comentarioSeguimiento,
        seguimientoIncidencia,
        guardarSeguimientoIncidencia,
        guardarParticipantes,
        eliminarSeguimientoIncidencia,
        loading
    } = useIncidencia()

    const {
        listarConceptosIncidencia,
        conceptosIncidencia,
        listarProducto,
        producto,
    } = useConceptoIncidencia()

    useEffect(() => {
        document.title = "PGI | Incidencia";
        (async () => {
            await listarProducto();
            await listarEmpresas();
            await listarAreas();
            await listarTipoCierre();
            await listarTipoUrgencia();
        })()
    },[])

    useEffect(() => {
       (async () => {
            procesosIncidencia.length === 0 && await listarProcesosIncidencia();
            await listarIncidencias(codigoEstado, startDate, endDate);
       })() 
    },[startDate, endDate, codigoEstado])

    const asincronaImg = async (imagenes) => {
        const urlImagen = await parseURLArchivo(imagenes);
        dispatch({ tipo: 'Cargar', carga: urlImagen});
    };

    const asincronaDoc = async (documentos) => {
        const urlDocumento = await parseURLArchivo(documentos);
        envioDoc({ tipo: 'Cargar', carga: urlDocumento});
    }

    useEffect(() => {
        if(procesoElegido !== 0){
            switch(procesoElegido){
                case 1:
                    listarConceptosIncidencia(detalleIncidencia.codProductoInterno);
                    imagenesValidacion.length > 0 ? asincronaImg(imagenesValidacion) : dispatch({tipo: 'Reiniciar'});
                    documentosValidacion.length > 0 ? asincronaDoc(documentosValidacion) : envioDoc({tipo: 'Reiniciar'});
                    break;
                case 2:
                    break;
                case 3:
                    if(numeroProceso === procesoElegido){
                        if(derivarIncidencia.codAreaDestino === stateUser.codAreaActual){
                            editarValorResolucion('fechaHoraInicioAtencion', formatDate(new Date()));
                        }
                    }
                    break;
                case 4:
                    imagenesCierre.length > 0 ? asincronaImg(imagenesCierre) : dispatch({tipo: 'Reiniciar'});
                    documentosCierre.length > 0 ? asincronaDoc(documentosCierre) : envioDoc({tipo: 'Reiniciar'});
                    break;
                case 5:
                    imagenesCierre.length > 0 ? asincronaImg(imagenesCierre) : dispatch({tipo: 'Reiniciar'});
                    documentosCierre.length > 0 ? asincronaDoc(documentosCierre) : envioDoc({tipo: 'Reiniciar'});
                    break;
                default:
                    dispatch({ tipo: 'Reiniciar'});
                    envioDoc({tipo: 'Reiniciar'});
                    break;
            }
        }
    },[procesoElegido])

    {/* LOGICA PARA EL GUARDADO DE ARCHIVOS */}
    const parseURLArchivo = async (archivos) => {
        return archivos.map(option => {
            const nuevoObjeto = {};
            Object.keys(option).forEach(key => {
                if(key === 'codIncidenciaArchivo'){
                    nuevoObjeto.codigo = option[key];
                }
                else
                    if(key.startsWith('nom')){
                        nuevoObjeto.nom = option[key];
                    }
                    else
                        if(key.startsWith('url')){
                            nuevoObjeto.url = option[key];
                        }
            });
            return nuevoObjeto;
        })
    }

    const registrarIncidenciaPGI = async () => {
        const camposAValidar = ["tituloIncidencia","descripcionIncidencia","codProductoInterno",
            "codEmpresaGeneral","codAreaDestino","codIncidenciaConcepto","codUrgencia"
        ];

        const validarRegistroInciencia = camposAValidar.some(campo => incidenciaPGI[campo] === "" || incidenciaPGI[campo] === null || incidenciaPGI[campo] === 0 || incidenciaPGI[campo] === undefined);
        if(validarRegistroInciencia){
            notify("Falta completar datos del formulario", "warning");
            return
        }
        const urlImagen = archivos.length > 0 ? await transformarArchivoUrl(archivos) : [];
        const urlDocumento = documentos.length > 0 ? await transformarArchivoUrl(documentos) : [];
        const archivosCombinados = [...urlImagen, ...urlDocumento]
        const isValid = await guardarIncidenciaPGI(archivosCombinados) 
        if(isValid){
            await listarIncidencias(codigoEstado, startDate, endDate)
            closeModalRegistro()
        }
    }

    const registrarValidacion = async () => {
        const camposAValidar = ["codUrgencia","codIncidenciaConcepto"];

        const validarInciencia = camposAValidar.some(campo => validarIncidencia[campo] === "" || validarIncidencia[campo] === null || validarIncidencia[campo] === 0 || validarIncidencia[campo] === undefined);
        if(validarInciencia){
            notify("Falta completar datos del formulario", "warning");
            return
        }
        const codigoIncidencia = detalleIncidencia.codIncidencia;
        const urlImagen = archivos.length > 0 ? await transformarArchivoUrl(archivos) : [];
        const urlDocumento = documentos.length > 0 ? await transformarArchivoUrl(documentos) : [];
        const archivosCombinados = [...urlImagen, ...urlDocumento]
        const isValid = await guardarValidacionIncidencia(codigoIncidencia, archivosCombinados)
        if(isValid)
        {
            await obtenerDetalleIncidencia(codigoIncidencia);
            if(!validarIncidencia.solucionado){
                setNumeroProceso(numeroProceso +1);
                setProcesoElegido(numeroProceso +1);
            }
            await listarIncidencias(codigoEstado, startDate, endDate)
        }
    }
    
    const registrarDerivacion = async () => {
        const camposAValidar = ["codAreaDestino"];

        const validarDerivarInciencia = camposAValidar.some(campo => derivarIncidencia[campo] === "" || derivarIncidencia[campo] === null || derivarIncidencia[campo] === 0 || derivarIncidencia[campo] === undefined);
        if(validarDerivarInciencia){
            notify("Falta completar datos del formulario", "warning");
            return
        }
        const isValid = await guardarDerivacionIncidencia(detalleIncidencia.codIncidencia);
        if(isValid){
            if(derivarIncidencia.codAreaDestino === stateUser.codAreaActual ){
                await guardarParticipantes(detalleIncidencia.codIncidencia)
            }
            await obtenerDetalleIncidencia(detalleIncidencia.codIncidencia);
            setNumeroProceso(numeroProceso +1);
            setProcesoElegido(numeroProceso +1);       
            await listarIncidencias(codigoEstado, startDate, endDate)
        }
    }

    const registrarResolucion = async () => {
        const camposAValidar = ["causaIncidencia","comentarioSolucion"];

        const validarResolverInciencia = camposAValidar.some(campo => resolverIncidencia[campo] === "" || resolverIncidencia[campo] === null || resolverIncidencia[campo] === 0 || resolverIncidencia[campo] === undefined);
        if(validarResolverInciencia){
            notify("Falta completar datos del formulario", "warning");
            return
        }
        const isValid = await guardarSolucionIncidencia(detalleIncidencia.codIncidencia)
        if(isValid){
            await obtenerDetalleIncidencia(detalleIncidencia.codIncidencia);
            setNumeroProceso(numeroProceso +1);
            setProcesoElegido(numeroProceso +1);       
            await listarIncidencias(codigoEstado, startDate, endDate)
        }
    }

    const registrarCierre = async () => {
        const camposAValidar = ["comentarioCierre"];

        const validarCierreInciencia = camposAValidar.some(campo => cierreIncidencia[campo] === "" || cierreIncidencia[campo] === null || cierreIncidencia[campo] === 0 || cierreIncidencia[campo] === undefined);
        if(validarCierreInciencia){
            notify("Falta completar datos del formulario", "warning");
            return
        }
        const urlImagen = archivos.length > 0 ? await transformarArchivoUrl(archivos) : [];
        const urlDocumento = documentos.length > 0 ? await transformarArchivoUrl(documentos) : [];
        const archivosCombinados = [...urlImagen, ...urlDocumento]
        const isValid = await guardarCierreIncidencia(detalleIncidencia.codIncidencia,archivosCombinados);
        if(isValid){
            await listarIncidencias(codigoEstado, startDate, endDate)
            cerrarModalProcesosIncidencia()
        }
    }

    const registrarSeguimiento = async () => {
        const isValid = await guardarSeguimientoIncidencia(codigoIncidencia)
        if(isValid){
            setComentarioSeguimiento('');
            await listaSeguimientoIncidencia(codigoIncidencia);
            await listarIncidencias(codigoEstado, startDate, endDate);
        }
    }

    const guardarSegunProceso = async ()  => {
        switch(procesoElegido){
            case 1:
                registrarValidacion();
                break;
            case 2:
                registrarDerivacion();
                break;
            case 3:
                registrarResolucion();
                break;
            case 4:
                registrarCierre()
                break;
            case 5:
                break;
            default:
                break;
        }
    }

    const guardarEliminarSeguimiento = async (codIncidenciaSeguimiento) => {
        const isValid = await eliminarSeguimientoIncidencia(codIncidenciaSeguimiento)
        if(isValid){
            await listarIncidencias(codigoEstado, startDate, endDate)
            await listaSeguimientoIncidencia(codigoIncidencia)
        }
    }

    const cerrarModalProcesosIncidencia = () => {
        closeModalProcesosIncidencia()
        setProcesoElegido(0);
        setNumeroProceso(0);
        dispatch({tipo: 'Reiniciar'});
        envioDoc({tipo: 'Reiniciar'});
        // setDespliegue(false);
    }

    const useFilteredData = (incidencias, filters) => {
        return useMemo(() => {
          return incidencias.filter(item => {
            // Filtrado por selectores
            const matchEmpresa = filters.codigoEmpresa === 0 || item.codEmpresaGeneral === filters.codigoEmpresa;
            const matchRuta = filters.codigoRuta === 0 || item.codRuta === filters.codigoRuta;
            const matchProducto = filters.codigoProducto === 0 || item.codProductoInterno === filters.codigoProducto;
            
            // Filtrado por texto de búsqueda
            const matchTexto = filters.textoBuscador.length === 0 || 
              Object.values(item).some(val => 
                typeof val === 'string' && val.toLowerCase().includes(filters.textoBuscador.toLowerCase())
              );
            
            return matchEmpresa && matchRuta && matchProducto && matchTexto;
          });
        }, [incidencias, filters]);
    };

    const handleFilterChange = (name, value) => {
        setFilters(prev => ({
          ...prev,
          [name]: value
        }));
      };

    const dataFiltrada = useFilteredData(incidencias, filters);

    const ordenarData = () => {
        const copiaIncidencias = [...dataFiltrada];
        return copiaIncidencias.sort((a, b) => {
            if (ordenConfig.campo === 'fecha') {
              const fechaA = formatearFechaHora(a.fechaHoraCreacion);
              const fechaB = formatearFechaHora(b.fechaHoraCreacion);
              return ordenConfig.direccion === 'ascendente' 
                ? fechaA - fechaB 
                : fechaB - fechaA;
            } else {
              // Ordenar por código de producto
              const codA = a.codProductoInterno;
              const codB = b.codProductoInterno;
              
              if (codA < codB) {
                return ordenConfig.direccion === 'ascendente' ? -1 : 1;
              }
              if (codA > codB) {
                return ordenConfig.direccion === 'ascendente' ? 1 : -1;
              }
              return 0;
            }
         });
    }

    const incidenciasOrdenadas = ordenarData();
    const empresasConvertidas = empresas.map(option => ({
        value: option.codEmpresa,
        label: primeraLetraMayuscula(option.nomEmpresa)
    }));

    const Fila = ({  index, style, data }) => {
        const inc = data.incidenciasOrdenadas[index];
        return(
            <>
                <section className='text-center px-2'>{index + 1}</section>
                <section className='flex justify-center px-2'>
                    <span
                        className={`bg-blue-600 relative  text-center block rounded px-2 w-[60px]`}
                    >{inc.codIncidencia}</span>
                </section>
                <section className="px-2">
                    <section className=' whitespace-nowrap text-ellipsis overflow-hidden' key={'div_' + inc.tituloIncidencia }>
                        {primeraLetraMayusculaOracion(inc.tituloIncidencia !== '' ? inc.tituloIncidencia : 'Incidencia registrada desde TGPS')}
                    </section>
                </section>
                <section className="px-2  whitespace-nowrap">{inc.nomProductoInterno}</section>
                <section className="px-2  whitespace-nowrap">
                    {primeraLetraMayusculaOracion(inc.nomEmpresa)}
                </section>
                <section className="px-2 text-center whitespace-nowrap">{inc.nomRuta}</section>
                <section className="px-2 text-center whitespace-nowrap">{inc.padronUnidad} {inc.placaUnidad}</section>
                <section className="text-center px-2 whitespace-nowrap text-ellipsis overflow-hidden">{inc.fechaHoraCreacion}</section>
                <section className="px-2 text-center whitespace-nowrap">{inc.uidCreacion || ''}</section>
                <section className='text-center px-2'>
                    <BotonProcesosPGI
                        procesos={procesosIncidencia}
                        openModal={openModalProcesosIncidencia}
                        numeroProceso={inc.nroOrdenActual||1}
                        setNumeroProceso={setNumeroProceso}
                        procesoElegido={procesoElegido}
                        setProcesoElegido={setProcesoElegido}
                        informacion={inc}
                        codEstado={inc.codEstado}
                        enProceso={inc.registraAtencion}
                        functionEjecutar={()=>obtenerDetalleIncidencia(inc.codIncidencia)}
                    />
                </section>
                {
                    codigoEstado != 50 ? 
                    <section className='flex items-center gap-x-2'>
                        <button
                            key={'btnSeguimiento_' + inc.codIncidencia}
                            className={` bg-green-500  px-1 rounded hover:shadow-inner ${inc.nroOrdenActual >= 2 ? '' : ' hidden '}`}
                            onClick={async () => {
                                await listaSeguimientoIncidencia(inc.codIncidencia)
                                setCodigoIncidencia(inc.codIncidencia);
                                setNumeroFilaSeguimiento(0);
                                openModalSeguimiento()
                            }}
                        >
                            <i className=' fa fa-plus'></i>
                        </button>
                        {
                            inc.nroOrdenActual >= 2  && inc.cantidadSeguimiento !== 0 ? 
                            <section
                                key={inc.codIncidencia + '_' + inc.tituloIncidencia}
                                className='w-[90%]  gap-x-[1px] flex overflow-x-auto containerScroll lg:w-auto'
                            > 
                            {
                                Array.from({length: inc.cantidadSeguimiento}).map((data, i) => (
                                    <div
                                        className='px-[5px] py-[2px] text-sm bg-yellow-500 rounded'
                                        onClick={async () => {
                                            setCodigoIncidencia(inc.codIncidencia);
                                            setNumeroFilaSeguimiento(i+1)
                                            await listaSeguimientoIncidencia(inc.codIncidencia)
                                            await openModalSeguimiento()
                                        }}
                                    >{i+1}</div>
                                ))
                            }
                            </section>
                            // <section className='text-center'>
                            //     <i className='fa fa-info-circle  '></i>
                            //     <span className='absolute  text-xs px-1 -top-2 bg-blue-500 rounded-full'>{inc.cantidadSeguimiento}</span>
                            // </section>
                            :
                            <></>
                        }
                    </section>
                    : <section></section>
                }
            </>
        );
    };

    const vistaValidar = () => (
        <div className="w-full overflow-y-auto scrollContainer" key={'vistaValidar'}>
            <fieldset className='w-full border border-zinc-500 grid items-center grid-cols-[minmax(0,25fr)_minmax(0,75fr)] gap-y-1 rounded px-4 py-2'>
                <legend className='font-bold text-zinc-300 '>Gestión de atención al cliente</legend>
                <span>Prioridad</span>
                <section
                    key={'_formularioRadio_prioridad_analisis'}
                    className='formularioRadio'
                >
                    <section
                        key={'radioPrioridad_analisis'}
                        className="radio relative lg:flex lg:w-[95%] "
                    >
                        {
                            tipoUrgencia.length > 0 ? 
                                tipoUrgencia.map((c,i) => (
                                    <div key={'prior_analisis_' + i} className='inline-flex'>
                                        <input
                                            disabled={numeroProceso <= procesoElegido ? false : true}
                                            type='radio' name="prioridad"
                                            value={c.codUrgencia}
                                            checked={validarIncidencia.codUrgencia === 0 ? ( c.codUrgencia === 3 ? true : false) : validarIncidencia.codUrgencia === c.codUrgencia }
                                            id={c.nomUrgencia}
                                            onChange={(e) => editarValorValidacion("codUrgencia",Number(e.target.value))}
                                        />
                                        <label
                                            className='lg:text-xs'
                                            htmlFor={c.nomUrgencia}
                                        >
                                            {(c.nomUrgencia)}
                                        </label>
                                    </div>
                                ))
                            :   <></>
                        }
                    </section>
                </section>
                <label htmlFor='txtComentarioAtencion'>Comentario</label>
                <textarea
                    id='txtComentarioAtencion'
                    disabled={numeroProceso <= procesoElegido ? false : true}
                    placeholder={numeroProceso <= procesoElegido ? 'Escriba aquí su comentario de atención...' : ''}
                    className={`h-[60px] ${classNameInput}  w-full lg:w-full  lg:h-[50px]`}
                    value={validarIncidencia.comentarioAtencion}
                    onChange={(e) => editarValorValidacion('comentarioAtencion', e.target.value)}
                />
                <label>Concepto</label>
                <select
                    className={`${classNameSelect} w-full`}
                    disabled={numeroProceso <= procesoElegido ? false : true}
                    value={validarIncidencia.codIncidenciaConcepto}
                    onChange={(e) => editarValorValidacion('codIncidenciaConcepto',Number(e.target.value))}
                >
                    <option value={0}>--Seleccione--</option>
                    {
                        conceptosIncidencia.length > 0 &&
                        conceptosIncidencia.map(data => (
                            <option key={data.codIncidenciaConcepto + '_option'} value={data.codIncidenciaConcepto}>{data.nomIncidenciaConcepto}</option>
                        ))
                    }
                </select>
                <section className='w-full col-span-2 grid grid-cols-[minmax(0,25fr)_minmax(0,75fr)] gap-y-1 items-center'>
                    <label className='lg:hidden'>Imagenes</label>
                    <ContenedorImagen
                        envioImagen={dispatch}
                        archivo={archivos}
                        className={'h-[300px]'}
                        esBloqueo={numeroProceso <= procesoElegido ? false : true}
                    />
                    <label className='lg:hidden'>Documentos</label>
                    <ContenedorDocumento
                        envioDocumento={envioDoc}
                        archivo={documentos}
                        className={'h-[100px]'}
                        esBloqueo={numeroProceso <= procesoElegido ? false : true}
                    />
                </section>
        
            </fieldset>
            <div className='w-full grid grid-cols-[minmax(0,25fr)_minmax(0,75fr)] items-center pt-2 hidden'> 
                <span className='lg:text-sm'>Cerrado</span>
                <SwitchToggle
                    keyEdit={'solucionado'}
                    setEdit={editarValorValidacion}
                    valor={validarIncidencia.solucionado}
                    disabled={numeroProceso <= procesoElegido ? false : true}
                />
                {
                    // validarIncidencia.solucionado && 
                    (
                        <fieldset className='col-span-2  pt-1 pb-2 border border-zinc-500 rounded px-4 gap-y-1 grid grid-cols-[minmax(0,25fr)_minmax(0,75fr)] items-center'>
                            <legend>Detalle de cierre</legend>
                                <span>Categoria cierre</span>
                                <select
                                    className={`${classNameSelect} `}
                                    value={validarIncidencia.codIncidenciaTipoCierre}
                                    onChange={(e)=> editarValorValidacion('codIncidenciaTipoCierre', Number(e.target.value))}
                                    // disabled={numeroProceso <= procesoElegido ? false : true}
                                    disabled={
                                        numeroProceso <= procesoElegido ? ( validarIncidencia.solucionado ? false : true ) : true 
                                    }
                                >
                                    <option value={0}>--Seleccione--</option>
                                    {
                                        tipoCierreIncidencia.length > 0 && 
                                            tipoCierreIncidencia.map(data => (
                                                <option
                                                    value={data.codIncidenciaTipoCierre}
                                                >{data.nomIncidenciaTipoCierre}</option>
                                            ))
                                    }
                                </select>
                                <label>Motivo cierre</label>
                                <textarea
                                    className={`${classNameInput} h-[80px] resize-none disabled:cursor-not-allowed`}
                                    onChange={(e) => editarValorValidacion('motivoIncidencia', e.target.value)}
                                    value={validarIncidencia.motivoIncidencia}
                                    disabled={numeroProceso <= procesoElegido ? ( validarIncidencia.solucionado ? false : true ) : true }
                                    // disabled
                                ></textarea>
                        </fieldset>
                    )
                }
            </div>
        </div> 
    )

    const vistaDerivar = () => {
        return(
            <div className="w-full" key={'_divDerivar'}>
                <fieldset className='w-full grid items-center grid-cols-[minmax(0,25fr)_minmax(0,75fr)] border border-zinc-500 gap-y-1 rounded px-4 py-2 lg:text-xs'>
                    <legend className='font-bold text-zinc-300 '>Derivación de incidencia</legend>
                    <span>Area a derivar</span>
                    <select
                        className={`${classNameSelect} text-center  lg:text-sm lg:h-[32px] disabled:cursor-not-allowed`}
                        disabled={numeroProceso <= procesoElegido ? false : true}
                        value={derivarIncidencia.codAreaDestino}
                        onChange={(e) => editarValorDerivacion('codAreaDestino', Number(e.target.value))}
                    >
                        <option value={0}>-- Seleccione --</option>
                        {
                            areas.map(a => (
                                <option
                                    key={a.codArea}
                                    value={a.codArea}
                                >{a.nomArea}</option>
                            ))
                        }
                    </select>
                    <label htmlFor='comentarioDerivar'>Comentario</label>
                    <textarea
                        id='comentarioDerivar' 
                        value={derivarIncidencia.comentarioDerivacionDestino}
                        disabled={numeroProceso <= procesoElegido ? false : true}
                        className={`${classNameInput} h-[80px] resize-none disabled:cursor-not-allowed`}
                        onChange={(e) => editarValorDerivacion('comentarioDerivacionDestino', e.target.value)}
                        placeholder='Escriba aquí su comentario...'
                    ></textarea>
                </fieldset>
            </div>
        )
    }

    const vistaResolver = () => (
        <div className='w-full' key={'vistaResolver'}>
            <fieldset className="w-full border rounded border-gray-600 px-4 py-2 grid grid-cols-[minmax(0,25fr)_minmax(0,75fr)] gap-2 items-cente">
                <legend className="font-bold ">Detalle de la resolución</legend>
                <span>Fecha atención</span>
                <input
                    className={`${classNameInput}`}
                    value={resolverIncidencia.fechaHoraInicioAtencion}
                    disabled
                    readOnly
                />
                <span>Participantes</span>
                {
                    resolverIncidencia.uidSolucionConcatenado !== '' ? 
                    <ul className='list-disc ml-5'>
                        {
                            resolverIncidencia.uidSolucionConcatenado.split(',').map(data => 
                                <li>{data}</li>
                            ) 
                        }
                    </ul>
                    : <span>
                        {
                            derivarIncidencia.codAreaDestino === stateUser.codAreaActual ? 
                            (
                                resolverIncidencia.uidSolucionConcatenado.split(',').includes(stateUser.nomUsuario.split('@')[0]) ? '' 
                                :
                                stateUser.nomUsuario.split('@')[0]) : ''
                         }
                    </span>
                }
                <span>Causa</span>
                <textarea
                    className={`${classNameInput} h-[80px] resize-none`}
                    onChange={(e) =>editarValorResolucion('causaIncidencia', e.target.value) }
                    value={resolverIncidencia.causaIncidencia}
                    disabled={procesoElegido === numeroProceso ? ( derivarIncidencia.codAreaDestino === stateUser.codAreaActual ? false : true ) : true}
                    readOnly={procesoElegido === numeroProceso ? ( derivarIncidencia.codAreaDestino === stateUser.codAreaActual ? false : true ) : true}
                />
                <span>Comentario solución</span>
                <textarea
                    className={`${classNameInput} h-[80px] resize-none`}
                    onChange={(e) => editarValorResolucion('comentarioSolucion', e.target.value)}
                    value={resolverIncidencia.comentarioSolucion}
                    disabled={procesoElegido === numeroProceso ? ( derivarIncidencia.codAreaDestino === stateUser.codAreaActual ? false : true ) : true}
                    readOnly={procesoElegido === numeroProceso ? ( derivarIncidencia.codAreaDestino === stateUser.codAreaActual ? false : true ) : true}
                />
                <span>Tiempo total atención</span>
                <input className={`${classNameInput}`} value={convertirSegundosAFormatoHr(resolverIncidencia.segundosTotalAtencion)} disabled readOnly/>
            </fieldset>
        </div>
    );

    const vistaFinalizar = () => (
        <div key={'vistaFinalizar'} className="w-full">
            <fieldset className="w-full border  grid items-center grid-cols-[minmax(0,25fr)_minmax(0,75fr)] border-zinc-500 gap-y-2 rounded px-4 py-2">
                <legend className="font-bold text-zinc-300">Finalizar Incidencia</legend>
                {
                    numeroProceso < procesoElegido ?
                    <>
                        <span>Concepto</span>
                        <select
                            className={`${classNameSelect} w-full`}
                            disabled={numeroProceso <= procesoElegido ? false : true}
                            value={cierreIncidencia.codIncidenciaConcepto}
                            onChange={(e) => editarValorCierre('codIncidenciaConcepto',Number(e.target.value))}
                        >
                            <option value={0}>--Seleccione--</option>
                            {
                                conceptosIncidencia.length > 0 &&
                                conceptosIncidencia.map(data => (
                                    <option key={data.codIncidenciaConcepto + '_option'} value={data.codIncidenciaConcepto}>{data.nomIncidenciaConcepto}</option>
                                ))
                            }
                        </select>
                    </>
                    :
                    <></>
                }
                <span>Categoria cierre</span>
                <select
                    className={`${classNameSelect} `}
                    value={cierreIncidencia.codIncidenciaTipoCierre}
                    onChange={(e)=> editarValorCierre('codIncidenciaTipoCierre', Number(e.target.value))}
                    disabled={numeroProceso <= procesoElegido ? false : true}
                >
                    <option value={0}>--Seleccione--</option>
                    {
                        tipoCierreIncidencia.length > 0 && 
                            tipoCierreIncidencia.map(data => (
                                <option
                                    value={data.codIncidenciaTipoCierre}
                                >{data.nomIncidenciaTipoCierre}</option>
                            ))
                    }
                </select>
                <label htmlFor='comentarioCierre'>Comentario</label>
                <textarea 
                    id='comentarioCierre'
                    className={`${classNameInput} h-[80px] resize-none`}
                    value={cierreIncidencia.comentarioCierre}
                    onChange={(e) => editarValorCierre('comentarioCierre' ,e.target.value)}
                    disabled={numeroProceso <= procesoElegido ? false : true}

                ></textarea>
                <section className='w-full col-span-2 grid grid-cols-[minmax(0,25fr)_minmax(0,75fr)] gap-y-1 items-center'>
                    <label className='lg:hidden'>Imagenes</label>
                    <ContenedorImagen
                        envioImagen={dispatch}
                        archivo={archivos}
                        className={'h-[250px]'}
                        esBloqueo={numeroProceso <= procesoElegido ? false : true}
                    />
                    <label className='lg:hidden'>Documentos</label>
                    <ContenedorDocumento
                        archivo={documentos}
                        envioDocumento={envioDoc}
                        className={'h-[120px] w-full'}
                        esBloqueo={numeroProceso <= procesoElegido ? false : true}
                    />
                </section>
            </fieldset>
        </div>
    );

    return (
        <>
        {loading && <LineaCarga/>}
            <ContenedorParametros titulo='Incidencias'>
                <MultiSelectorFecha
                    setStartDate={setStartDate}
                    setEndDate={setEndDate}
                    startDate={startDate}
                    endDate={endDate}
                />
                <i className='fa fa-filter ' data-tip="estados" data-for="estados"></i>
                <Tooltip id="estados" key={'selectEstado'}>Estados</Tooltip>
                <select
                    value={codigoEstado}
                    className={`${classNameSelect} py-[5px] lg:w-[100px] lg:text-sm`}
                    onChange={(e) => setCodigoEstado(Number(e.target.value))}
                >
                    <option key={'optionTodos_Estado'} value={0}>--Todos--</option>
                    {
                        estadosSolicitudes.length > 0 ?
                            estadosSolicitudes.map(est => (
                                <option key={est.codEstado} value={est.codEstado}>{est.nomEstado}</option>
                            ))
                        : <option key={-1} value={-1}>No hay información</option>
                    }
                </select>
                <i className='fa fa-building' data-tip="tool_Empresa" data-for="tool_Empresa"></i>
                <Tooltip id="tool_Empresa" key={'selectEmpresa'}>Empresas</Tooltip>
                <select 
                    value={filters.codigoEmpresa}
                    className={`${classNameSelect}`}
                    onChange={(e) => {
                        handleFilterChange('codigoEmpresa',Number(e.target.value));
                        ( Number(e.target.value) !== 0 && Number(e.target.value) !== 4 ) ? listarRutasPorEmpresa(Number(e.target.value)) : handleFilterChange('codigoRuta',0)
                    }} 
                >
                    <option key={'optionTodos_Empresa'} value={0}>--Todos--</option>
                    {
                        empresas.length > 0 ? 
                            empresas.map(e => (
                                <option key={e.codEmpresa} value={e.codEmpresa}>{e.nomEmpresa}</option>
                            ))
                        :
                        <option key={-1} value={-1}>No hay información</option>
                    }
                </select>
                {
                    (filters.codigoEmpresa !== 4 && filters.codigoEmpresa !== 0) &&
                    (
                        <>
                            <i className='fa fa-filter' data-tip="tool_Ruta" data-for="tool_Ruta"></i>
                            <Tooltip id="tool_Ruta" key={'selectRuta'}>Rutas</Tooltip>
                            <select
                                className={`${classNameSelect}`}
                                onChange={(e) => handleFilterChange('codigoRuta',Number(e.target.value))}
                                value={filters.codigoRuta}
                            >
                                <option key={'optionTodos_Ruta'} value={0}>--Todos--</option>
                                {
                                    rutas.length > 0 ? 
                                        rutas.map(e => (
                                            <option key={e.codRuta} value={e.codRuta}>{e.nomRuta}</option>
                                        ))
                                    :
                                    <option key={-1} value={-1}>No hay información</option>
                                }
                            </select>
                        </>

                    )
                }
                 <i className="fa fa-filter" data-for={'tool_Producto'} data-tip={'tool_Producto'}></i>
                <Tooltip id={'tool_Producto'} key={'selectProducto'}>Tipo de producto</Tooltip>
                <select
                    value={filters.codigoProducto}
                    className={`${classNameInput}`}
                    onChange={(e) =>handleFilterChange('codigoProducto',Number(e.target.value))}
                >
                    {
                        <option key={'optionTodos_Producto'} value={0}>--Todos--</option>
                    }
                    {
                        producto.length > 0 ?
                            producto.map(p => (
                                <option key={p.codProductoInterno} value={p.codProductoInterno}>{p.nomProductoInterno}</option>
                            ))
                        :
                        <option key={-1} value={-1}>No hay información</option>
                    }
                </select>
                <BotonProcesar onClick={()=> listarIncidencias(codigoEstado, startDate, endDate)}/>

                <BotonNuevo
                    onClick={async () => {
                        dispatch({tipo: 'Reiniciar'})
                        envioDoc({tipo: 'Reiniciar'});
                        resetIncidenciaPGI();
                        resetUnidades();
                        await openModalRegistro()
                        // cambiarOpcionArea(stateUser.codAreaActual,1)
                    }}
                >
                </BotonNuevo>

            </ContenedorParametros>
            <Buscador setValorBuscador={handleFilterChange} valorBuscador={filters.textoBuscador}></Buscador>
            <div className="mt-8 relative top-0 bottom-0 left-0 right-0 overflow-hidden contenedor-tabla  lg:w-full  lg:overflow-auto">
                <table id={idTablaIncidencias} className=" tableResponsive ">
                    <thead>
                        {/* <tr key={'head-1'} className={` uppercase ${incidenciasOrdenadas.length > 24 ? ' w-[99.5%] ' : ' w-full '} grid grid-cols-[3%_5%_10%_20%_7%_20%_5%_10%_10%_10%]`}> */}
                        <tr key={'head-1'} className={` uppercase ${incidenciasOrdenadas.length > 24 ? ' w-[99.5%] ' : ' w-full '} grid grid-cols-[3%_5%_20%_7%_20%_5%_7%_10%_8%_10%_5%]`}>
                            <th className=" text-center" data-sort="int">N</th>
                            <th className=' text-center'>Ticket</th>
                            <th className="text-left">Incidencia</th>
                            <th className="text-left">
                                <span>TIPO</span>
                                <i
                                    className={`fa fa-sort-amount-${ordenConfig.campo === 'producto' ? (ordenConfig.direccion === 'ascendente' ? 'desc' : 'asc') : 'asc'} pl-3`}
                                    data-tip={'ordenarProducto'}
                                    data-for="ordenarProducto"
                                    onClick={() => setOrdenConfig({
                                        campo: 'producto',
                                        direccion: ordenConfig.campo === 'producto' ?
                                            (ordenConfig.direccion === 'ascendente' ? 'descendente' : 'ascendente')
                                            : 'ascendente'
                                        })
                                    }
                                ></i>
                                <Tooltip id="ordenarProducto">
                                    {ordenConfig.direccion === 'ascendente' ? 'Orden descendente' : 'Orden ascendente'}
                                </Tooltip>
                                
                            </th>
                            <th className="text-left">Empresa solicitante</th>
                            <th className="text-center">RUTA</th>
                            <th className="text-center">UNIDAD</th>
                            <th className=" text-center">
                                <span>F. registro</span>
                                <i
                                    className={`fa fa-sort-amount-${ordenConfig.campo === 'fecha' ? (ordenConfig.direccion === 'ascendente' ? 'desc' : 'asc') : 'asc'} pl-3`}
                                    data-tip={'ordenar'}
                                    data-for={'ordenar'}
                                    onClick={() => setOrdenConfig({
                                        campo: 'fecha',
                                        direccion: ordenConfig.campo === 'fecha' 
                                          ? (ordenConfig.direccion === 'ascendente' ? 'descendente' : 'ascendente')
                                          : 'ascendente'
                                        })
                                    }
                                ></i>
                                <Tooltip id={'ordenar'}>
                                    {ordenConfig.direccion === 'ascendente' ? 'Orden descendente' : 'Orden ascendente'}
                                </Tooltip>
                            </th>
                            <th>U.CREACIÓN</th>
                            <th className="text-center">Procesos</th>
                            {
                                codigoEstado !== 50 ? 
                                <th className="text-center">Seguimiento</th>
                                : <th></th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            incidenciasOrdenadas.length > 0 ?
                                <Lista
                                    altura={750}
                                    cantidadTotal={incidenciasOrdenadas.length}
                                    largoItem={33}
                                    // anchoColumnas="3% 5% 10% 20% 7% 20% 5% 10% 10% 10%"
                                    anchoColumnas="3% 5% 20% 7% 20% 5% 7% 10% 8% 10% 5%"
                                >
                                    {({ index, style })  =>{
                                        return (
                                            <Fila
                                                key={'tr_' + index}
                                                index={ index }
                                                style={ style }
                                                data={{ incidenciasOrdenadas }}
                                            />
                                        )
                                    }
                                    }
                                </Lista>
                            :
                            <tr className='row' style={{display: 'table-row'}}><td  colSpan={7} className='text-center'>No hay información para mostrar...</td></tr>
                        }
                    </tbody>
                </table>
            </div>

            {/* Modal para registrar incidencia */}
            <Modal
                isOpen={isOpenModalRegistro}
                closeModal={closeModalRegistro}
                // action={() => registrarIncidencia()}
                action={() => registrarIncidenciaPGI()}
                title={'Crear Incidencia'}
                spinner={{}}
                validButton = {{
                    confirm: true,
                    denied: true,
                }}
                textButtons={{
                    confirm: 'Guardar',
                    denied: 'Cancelar',
                }}
            >
                <section className='max-w-[520px] p-1 overflow-y-auto max-h-[650px] containerScroll gap-2 grid grid-cols-[minmax(0,2fr)_minmax(0,8fr)] items-center'>
                    <label className='lg:text-sm ' htmlFor='txtTitulo'>Título</label>
                    <input
                        id='txtTitulo'
                        className={`lg:text-xs  ${classNameInput} `}
                        onChange={(e) => editarValorRegistroIncidencia('tituloIncidencia', e.target.value)}
                        value={incidenciaPGI.tituloIncidencia}
                    />
                    <span className='lg:text-sm'>Empresa</span>
                    <NuevoSelectAutocomplete
                        options={empresasConvertidas}
                        valorInput={(valor) => {editarValorRegistroIncidencia("codEmpresaGeneral", valor);}}// listarUbicacionMenu(valor)}}
                        valorPorDefecto={incidenciaPGI.codEmpresaGeneral}
                        opcionSeleccione={true}
                        funcionListar={listarUnidadesPorEmpresa}
                    ></NuevoSelectAutocomplete>
                    <span className='lg:text-sm'>Área destino</span>
                    <select
                        className={`lg:h-[30px] lg:text-xs col-span-1 ${classNameSelect}`}
                        onChange={(e) => editarValorRegistroIncidencia("codAreaDestino", Number(e.target.value))}
                        value={incidenciaPGI.codAreaDestino}
                    >
                        <option value={0}>--Selecccione--</option>
                        {
                            areas.length > 0 &&
                                areas.map((a,i) => (
                                    <option key={i+1} value={a.codArea}>{a.nomArea}</option>
                                ))
                        }
                    </select>
                    <section className='w-full col-span-2 grid gap-2  grid-cols-[minmax(0,205fr)_minmax(0,295fr)_minmax(0,205fr)_minmax(0,295fr)] items-center'>
                        <span className='lg:text-sm col-span-1'>Producto</span>
                        <select
                            className={` text-[15px] lg:h-[30px] lg:text-xs col-span-1 ${classNameSelect}`}
                            onChange={(e) => {
                                editarValorRegistroIncidencia('codProductoInterno', Number(e.target.value))
                                listarConceptosIncidencia(e.target.value)
                            }}
                            value={incidenciaPGI.codProductoInterno}
                        >
                            <option value={0}>--Selecccione--</option>
                            {
                                producto.length > 0 &&
                                producto.map(a => (
                                    <option key={a.codProductoInterno} value={a.codProductoInterno}>{a.nomProductoInterno}</option>
                                ))
                            }
                        </select>
                        <span className={`lg:text-sm col-span-1 text-center ${incidenciaPGI.codProductoInterno === 3 ? 'hidden' : '' }`}>Unidad</span>
                        <select
                            className={`lg:h-[30px] lg:text-xs col-span-1 ${classNameSelect}  ${incidenciaPGI.codProductoInterno === 3 ? 'hidden' : '' }`}
                            onChange={(e) => {
                                editarValorRegistroIncidencia('codUnidad', Number(e.target.value))
                                editarValorRegistroIncidencia('placaUnidad',e.target.options[e.target.selectedIndex].dataset.placaunidad)
                                editarValorRegistroIncidencia('padronUnidad',e.target.options[e.target.selectedIndex].dataset.padronunidad)
                            }}
                        >
                            <option value={0} >--Selecccione--</option>
                            {
                                unidades.length > 0 ? 
                                    unidades.map(uni => (
                                        <option
                                            key={uni.codUnidad}
                                            data-placaunidad={uni.placaUnidad}
                                            data-padronunidad={uni.padronUnidad}
                                            value={uni.codUnidad}
                                        >{uni.placaUnidad} ({uni.padronUnidad})</option>
                                    ))
                                : <></>
                            }
                        </select>
                    </section>
                    <span className='lg:text-sm'>Concepto</span>
                    <select
                        className={`lg:h-[30px] lg:text-xs col-span-1 ${classNameSelect}`}
                        onChange={(e) => editarValorRegistroIncidencia('codIncidenciaConcepto', Number(e.target.value))}
                    >
                        <option value={0} >--Selecccione--</option>
                        {
                            conceptosIncidencia?.length > 0 &&
                                conceptosIncidencia.map((c,i) => (
                                    <option key={c.codIncidenciaConcepto} value={c.codIncidenciaConcepto}>{c.nomIncidenciaConcepto}</option>
                                ))
                        }
                    </select>
                    <label className='lg:text-sm' htmlFor='obj'>Descripción</label>
                    <div className='w-full flex lg:gap-2 lg:items-center'>
                        <button
                            className={`lg:w-[9%] border lg:visible hidden text-l h-[30px] fa fa-microphone text-white lg:flex lg:justify-center
                            ${listening ? ' bg-yellow-700 ' : ' bg-green-800 '} rounded py-1 px-2`}
                            onClick={()=>SpeechRecognition.startListening()}

                        >
                            {listening &&
                                <span className="absolute top-[-22px] right-[-10px] flex h-3 w-3">
                                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                                    <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
                                </span>
                            }
                        </button>
                        <textarea
                            id='obj'
                            className={`w-full ${classNameInput} h-[80px] lg:w-[91%] resize-none lg:text-xs`}
                            value={incidenciaPGI.descripcionIncidencia}
                            onChange={(e)=>editarValorRegistroIncidencia('descripcionIncidencia',e.target.value)}
                        />
                    </div>
                    <span className='lg:text-sm'>Imágenes</span>
                    <ContenedorImagen
                        archivo={archivos}
                        envioImagen={dispatch}
                        className={'h-[120px] w-full '}
                        // showThumbs={true}
                    />
                    <span className='lg:text-sm '>Documentos</span>
                    <ContenedorDocumento
                        envioDocumento={envioDoc}
                        archivo={documentos}
                        className={'h-[120px]'}
                    />
                    <span className='lg:text-sm '>Prioridad</span>
                    <section
                        key={'_formularioRadio_prioridad'}
                        className='formularioRadio'
                    >
                        <section
                            key={'radioPrioridad'}
                            className="radio relative lg:flex lg:w-[95%] "
                        >
                            {
                                tipoUrgencia.map((c,i) => (
                                    <div key={'prior_' + i} className='inline-flex'>
                                        <input
                                            key={i+1}
                                            type='radio' name="prioridad"
                                            value={c.codUrgencia}
                                            checked={incidenciaPGI.codUrgencia === c.codUrgencia}
                                            id={c.nomUrgencia}
                                            onChange={(e) => {
                                                editarValorRegistroIncidencia("codUrgencia",Number(e.target.value))}
                                            }
                                        />
                                        <label
                                            key={i}
                                            className='lg:text-xs'
                                            htmlFor={c.nomUrgencia}
                                        >
                                            {(c.nomUrgencia)}
                                        </label>
                                    </div>
                                ))

                            }
                        </section>
                    </section>
                    <span className='lg:text-sm'>Cerrado</span>
                    <SwitchToggle
                        keyEdit={'solucionado'}
                        setEdit={editarValorRegistroIncidencia}
                        valor={incidenciaPGI.solucionado}
                    />
                    {
                        incidenciaPGI.solucionado ? 
                            <div className=' gap-2  w-full col-span-2 grid grid-cols-[minmax(0,2fr)_minmax(0,8fr)] items-center'>
                                <span>Categoria cierre</span>
                                <select
                                    className={`${classNameSelect}`}
                                    value={incidenciaPGI.codIncidenciaTipoCierre}
                                    onChange={(e)=> editarValorRegistroIncidencia('codIncidenciaTipoCierre', Number(e.target.value))}
                                >
                                    <option value={0}>--Seleccione--</option>
                                    {
                                        tipoCierreIncidencia.length > 0 && 
                                            tipoCierreIncidencia.map(data => (
                                                <option
                                                    value={data.codIncidenciaTipoCierre}
                                                >{data.nomIncidenciaTipoCierre}</option>
                                            ))
                                    }
                                </select>
                                <label>Comentario cierre</label>
                                <textarea
                                    className={`${classNameInput} h-[80px] resize-none`}
                                    onChange={(e) => editarValorRegistroIncidencia('comentarioSolucion', e.target.value)}
                                    value={incidenciaPGI.comentarioSolucion}
                                ></textarea>
                            </div>
                        :   <></>
                    }
                </section>
            </Modal>

            {/*Modal para ver los procesos de la incidencia */}
            <Modal
                isOpen={isOpenModalProcesosIncidencia}
                closeModal={cerrarModalProcesosIncidencia}
                validButton={{
                    confirm: procesoElegido < numeroProceso  ? false : (numeroProceso === 5 ? false : ( numeroProceso === 3 ? (stateUser.codAreaActual === derivarIncidencia.codAreaDestino ? true : false) : true)),
                    denied: true
                }}
                textButtons={{
                    confirm: numeroProceso === 1 ?  'Guardar' : 'Guardar',
                    denied: 'Cerrar'
                }}
                action={() => guardarSegunProceso()}
                padding={'p-0'}
                title={detalleIncidencia.tituloIncidencia}
                classNameOther={'bg-red-600 hover:bg-red-800'}
                width={'w-[1000px] h-[850px]'}
            >
                <div
                    className='grid grid-rows-[minmax(0,07fr)_minmax(0,93fr)] lg:grid-rows-[minmax(0,05fr)_minmax(0,95fr)] h-full lg:w-auto overflow-hidden'
                    key={'_Contenedor'}
                >
                    <section
                        className='bg-[#1D1E1E]'
                        key={'_Cabecera'}
                    >
                        <DetalleIncidencia
                            titulo={`Ticket N° ${detalleIncidencia.codIncidencia}`}
                            // alturaDetalle={''}
                            setDespliegue={setDespliegue}
                            despliegue={despliegue}
                        >
                            <section className='w-full h-full grid grid-cols-[minmax(0,5fr)_minmax(0,5fr)] gap-5 items-start'>
                                <section className='grid grid-cols-[minmax(0,3fr)_minmax(0,7fr)] gap-2 items-center'>
                                    <span>Empresa solicitante</span>
                                    <input
                                        className={`${classNameInput}`}
                                        value={detalleIncidencia.nomEmpresa}
                                        disabled
                                        readOnly
                                    />
                                    <span>Producto</span>
                                    <input
                                        className={`${classNameInput}`}
                                        value={detalleIncidencia.nomProductoInterno}
                                        disabled
                                        readOnly
                                    />
                                    <span>Concepto</span>
                                    <input
                                        className={`${classNameInput}`}
                                        value={detalleIncidencia.nomIncidenciaConcepto}
                                        disabled
                                        readOnly
                                    />
                                    <section
                                        className={`${detalleIncidencia.codProductoInterno === 3 && 'hidden'}
                                        col-span-2 grid w-full grid-cols-[minmax(0,31fr)_minmax(0,19fr)_minmax(0,20fr)_minmax(0,30fr)] gap-2 items-center`}
                                    >
                                        <span>Ruta</span>
                                        <input
                                            className={`${classNameInput}`}
                                            // value={detalleIncidencia.}
                                            disabled
                                            readOnly
                                        />
                                        <span>Unidad</span>
                                        <input
                                            className={`${classNameInput}`}
                                            disabled
                                            readOnly
                                            value={detalleIncidencia.padronUnidad + ' - ' + detalleIncidencia.placaUnidad}
                                        />
                                    </section>
                                    {
                                        imagenesTgps.length > 0 ? 
                                        (
                                            <>
                                                <span>Imagen</span>
                                                <div className={`${classNameInput} gap-2 overflow-x-auto items-center flex h-[100px] `}>
                                                    {
                                                        imagenesTgps.map(data => (
                                                            <img
                                                                alt=''
                                                                key={data.codIncidenciaArchivo + '_img_'}
                                                                src={data.urlArchivo}
                                                                className='w-[80px] h-[60px] cursor-zoom-in'
                                                                onClick={() => window.open(data.urlArchivo,'_blank')}
                                                            ></img>
                                                        ))
                                                    }
                                                </div>
                                            </>
                                        )
                                        : <></>
                                    }
                                </section>
                                <section className='grid grid-cols-[minmax(0,3fr)_minmax(0,7fr)] gap-2 items-center'>
                                    <span>Usuario registro</span>
                                    <input
                                        className={`${classNameInput}`}
                                        value={detalleIncidencia.uidCreacion}
                                        disabled
                                        readOnly
                                    />
                                    <span>Nro. contacto</span>
                                    <input className={`${classNameInput}`}  disabled readOnly/>
                                    <span>Fecha hora registro</span>
                                    <input
                                        className={`${classNameInput}`}
                                        value={detalleIncidencia.fechaHoraCreacion}
                                        disabled
                                        readOnly
                                    />
                                    <section
                                        className={` ${detalleIncidencia.codProductoInterno === 3 && 'hidden'}
                                        col-span-2 grid w-full grid-cols-[minmax(0,31fr)_minmax(0,24fr)_minmax(0,15fr)_minmax(0,30fr)] gap-2 items-center`}
                                    >
                                        <span>Versión</span>
                                        <input className={`${classNameInput}`} value={detalleIncidencia.versionEnquipo||''} disabled readOnly/>
                                        <span>Modelo</span>
                                        <input className={`${classNameInput}`} value={detalleIncidencia.modeloEquipo||''} disabled readOnly/>
                                    </section>
                                    <span className={`${detalleIncidencia.codProductoInterno === 3 && 'hidden'}`}>Vigencia</span>
                                    <input className={`${classNameInput} ${detalleIncidencia.codProductoInterno === 3 && 'hidden'}`} value={convertirFormatoDias(detalleIncidencia.vigenciaEquipo)||''} disabled readOnly/>
                                    <section className='row-span-2 col-span-2 grid w-full grid-cols-[minmax(0,3fr)_minmax(0,7fr)] gap-2 items-center'>
                                        <span>Descripción</span>
                                        <textarea
                                            className={`${classNameInput} resize-none h-[100px]`}
                                            value={detalleIncidencia.descripcionIncidencia}
                                            disabled
                                            readOnly
                                        />
                                    </section>
                                </section>
                            </section>
                        </DetalleIncidencia>
                    </section>

                    <section
                        className='w-full h-full grid grid-cols-[minmax(0,18fr)_minmax(0,82fr)] lg:grid-cols-1 lg:grid-rows-[minmax(0,1fr)_minmax(0,9fr)] lg:w-auto'
                        key={'_Cuerpo'}
                    >
                        <section
                            key={'_Botones'}
                            className='h-full grid lg:grid-cols-4 gap-2 bg-[#2B2C2E] items-center px-4 py-2 lg:w-full '
                        >
                            <ContenedorBotones
                                procesos={procesosIncidencia}
                                numeroProceso={numeroProceso}
                                procesoElegido={procesoElegido}
                                setProcesoElegido={setProcesoElegido}
                            />
                        </section>
                        <section
                            className='p-5 overflow-y-auto containerScroll lg:w-auto'
                            key={'_Vistas'}
                        >
                            {
                                procesoElegido === 1 ? vistaValidar() :
                                    (procesoElegido === 2 ? vistaDerivar() : 
                                    (procesoElegido === 3 ? vistaResolver() : vistaFinalizar()))
                            }
                        </section>
                    </section>
                </div>
            </Modal>

            {/* */}
            <Modal
                // isOpen={true}
                isOpen={isOpenModalSeguimiento}
                closeModal={closeModalSeguimiento}
                action={() => registrarSeguimiento()}
                title={`Seguimiento por incidencia [${codigoIncidencia}]`}
                validButton = {{
                    confirm: false,
                    denied: true,
                }}
                textButtons={{
                    confirm: 'Guardar',
                    denied: 'Cancelar',
                }}
            >
                <section className='w-[800px] px-4'>
                    <table className='tableResponsive'>
                        <thead>
                            <tr>
                                <th className='text-center'>N</th>
                                <th className='text-center'>COD</th>
                                <th className='text-center'>COMENTARIO</th>
                                <th className='text-center'>USUARIO</th>
                                <th className='text-center'>FECHA CREACIÓN</th>
                                <th className='text-center'></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                seguimientoIncidencia.map((seg,i) => (
                                    <tr
                                        className={`row `}
                                        style={{background: numeroFilaSeguimiento === (i + 1)  ? 'rgb(96 165 250 / var(--tw-bg-opacity))' : ''}}
                                    >
                                        <td className='text-center'>{i+1}</td>
                                        <td className='text-center'>
                                            <span className='bg-blue-500 px-2 rounded'>{seg.codIncidenciaSeguimiento}</span>
                                        </td>
                                        <td>{seg.comentario}</td>
                                        <td className='text-center'>{seg.uidCreacion}</td>
                                        <td className='text-center'>{seg.fechaHoraCreacion}</td>
                                        <td className='text-center'>
                                            {
                                                seg.uidCreacion === stateUser.nomUsuario.split('@')[0]
                                                ?
                                                <i className='fa fa-trash text-red-600 cursor-pointer' onClick={()=> guardarEliminarSeguimiento(seg.codIncidenciaSeguimiento)}></i>
                                                :
                                                <></>
                                            }
                                        </td>
                                    </tr>
                                ))
                            }
                            <tr className=''>
                                <td colSpan={6}>
                                    <section className='flex gap-x-2 w-full items-center'>
                                        <input
                                            className={`${classNameInput} w-full`}
                                            placeholder='Escribir aquí...'
                                            value={comentarioSeguimiento}
                                            onChange={(e)=> setComentarioSeguimiento(e.target.value)}
                                            onKeyUp={(e)=> e.keyCode === 13 && registrarSeguimiento() }
                                        />
                                        <i className='fa fa-paper-plane px-2 py-1 rounded bg-blue-500 cursor-pointer' onClick={()=> registrarSeguimiento()}></i>
                                    </section>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </section>
            </Modal>
        </>
    )
}